/* Single – eenvoudige gallery thumb → stage swap */
export function mount() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wc-gallery__thumb');
    if (!btn) return;
    const fig = btn.closest('[data-gallery]');
    if (!fig) return;

    const src = btn.getAttribute('data-src');
    const stageImg = fig.querySelector('.wc-gallery__stage img');
    if (stageImg && src) {
      stageImg.src = src;
      stageImg.srcset = '';
      fig.querySelectorAll('.wc-gallery__thumb').forEach(t => t.classList.remove('is-active'));
      btn.classList.add('is-active');
    }
  });
}
